import { render, staticRenderFns } from "./PagesFilterDropdown.vue?vue&type=template&id=67e0873a&"
import script from "./PagesFilterDropdown.vue?vue&type=script&lang=js&"
export * from "./PagesFilterDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports